// utils/apiClient.js
import axios from "axios";
import { showError, showSuccess } from "./toastUtils";
import { decryptData } from "../crypto";

const baseURL = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
  baseURL: baseURL,
});

api.interceptors.request.use(
  (config) => {
    const encryptedToken = sessionStorage.getItem("token");
    if (encryptedToken) {
      const token = decryptData(encryptedToken);
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const apiClient = async (method, url, data, showToast = true) => {
  try {
    const response = await api.request({
      method,
      url,
      data,
    });

    // Optional: show success toast
    // if (showToast) {
    //   showSuccess(response?.data?.message || "Success");
    // }

    return response.data;
  } catch (error) {
    const errMsg =
      error.response?.data?.message || error.message || "Something went wrong";

    if (showToast) {
      showError(errMsg);
    }

    throw error;
  }
};
